import { render, staticRenderFns } from "./edit-forward-incoming-calls-dialog.vue?vue&type=template&id=95b018d2&scoped=true&"
import script from "./edit-forward-incoming-calls-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-forward-incoming-calls-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b018d2",
  null
  
)

export default component.exports